export default "__VITE_ASSET__73a20d4e__"